import template from './myLoansFilters.html';
import controller from './myLoansFilters.controller';
import './myLoansFilters.scss';

let myLoansFiltersComponent = {
  restrict: 'E',
  bindings: {
    filterByStatus: '&',
    objectStatesFilter: '<',
  },
  template,
  controller
};

export default myLoansFiltersComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoansFilters/myLoansFilters.component.js